<style lang="less" scoped>
  .file-uploader {
    position: relative;
    width: 96px;
    height: 36px;
    &:hover {
      background: #fff0e6;
      border-color: #fff0e6;
    }
  }
  .file-button {
    position: absolute;
    top: 0;
    left: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-flow: column wrap;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
</style>

<template lang="pug">
  .file-uploader
    input(
      :id="id",
      type="file",
      style="display: none",
      @change="upload",
      accept="image/*")
    label.file-button(:for="id")
      p.file-uploader-text {{ label }}
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: 'file',
    },
    label: {
      type: String,
      default: '찾아보기',
    },
  },
  methods: {
    upload(e) {
      this.$emit('upload', e);
    },
  },
};
</script>
